import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Slider } from '@mui/material';

import styles from "./IndEvent.module.css"
import guestii from '../../assets/images/logos/guestii_white.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'

import Sidebar from '../Sidebar';
import DashboardModule from './DashboardModule';
import GuestiiModule from './GuestiiModule';
import TeamModule from './TeamModule';
import InviteGuestiiModule from './InviteGuestiiModule'
import InviteTeamModule from './InviteTeamModule'
import AnnouncementsModule from './AnnouncementsModule'
import { GuestiiTypes, GuestiiTags, GuestiiPlusOnes, GuestiiRating, GuestiiPromoters } from './EditGuestiiModules'
import { PromoterLimits } from './EditTeamModules'


const Banner = () => {
	const navigate = useNavigate();
	const [showingLabel, setShowingLabel] = useState(true)
	const [search, setSearch] = useState("")
	const divRef = useRef(null);
	const [userData, setUserData] = useState({})
	const [searchResults, setSearchResults] = useState({
		events: [],
		guestiis: [],
		teamMembers: []
	})

	useEffect(() => {
		const handleLoad = async () => {
			try {
				const userId = localStorage.getItem("_id")
				const retrieve = await axios.get(`/api/hub/get-user-data/${userId}`);
				setUserData(retrieve.data.user)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}

		handleLoad()
	}, []);


	const handleSearch = async (input) => {
		const userId = localStorage.getItem("_id")
		const searchTerm = input.target.value
		setSearch(searchTerm)

		if (searchTerm !== "") {
			const retrieve = await axios.get(`/api/hub/${userId}/search-all/${searchTerm}`);
			setSearchResults(retrieve.data.data)
		}
	}

	function formatDate(dateString) {
	    const date = new Date(dateString);

	    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	    const day = days[date.getDay()];
	    const dateNumber = date.getDate();
	    const month = months[date.getMonth()];

	    const suffix =
	        dateNumber % 10 === 1 && dateNumber !== 11
	            ? 'st'
	            : dateNumber % 10 === 2 && dateNumber !== 12
	            ? 'nd'
	            : dateNumber % 10 === 3 && dateNumber !== 13
	            ? 'rd'
	            : 'th';

	    return `${day}, ${dateNumber}${suffix} ${month}`;
		}

		function convertTo24HourTime(isoString) {
	    const date = new Date(isoString);
	    const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

	    return time;
	}

	const handleClickOutside = (event) => {
	  	if (divRef.current && !divRef.current.contains(event.target)) {
	  		setSearch("")

				setSearchResults({
					events: [],
					guestiis: [],
					teamMembers: []
				})
	  	}
	};

	const handleClickItem = (item, searchKey) => {
		const userId = localStorage.getItem("_id")

		switch (searchKey) {
			case 'guestiis':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				navigate(`/guestiis/${userId}`)
				break;
			case 'teamMembers':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				navigate(`/team/${userId}`)
				break;
		}

	}

	useEffect(() => {
  	document.addEventListener('mousedown', handleClickOutside);

  	return () => {
    		document.removeEventListener('mousedown', handleClickOutside);
  	};
	}, []);

	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_greeting}>
				<h3>Hi, {userData.first_name}</h3>
				<p>Welcome back to your Guestii hub!</p>
			</div>

			<div className={styles.banner_tools}>
				<div className={styles.nevent_input_container_search}>
					<div
						className={styles.movingLabelSearch}
			        	style={{
				          	top: showingLabel && !search ? "50%" : "-20px",
				          	transform: showingLabel && !search ? "translate(0, -50%)" : "",
				          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, color 0.3s ease",
				          	color: !(showingLabel && !search) && "#01000D"
			        	}}
					>
						<i className={`fa-solid fa-magnifying-glass ${styles.m1}`}></i>
						<p className={`${styles.s1}`}>Search for anything</p>
					</div>

					<input
						type="text"
						className={styles.s1}
						onChange={(input) => handleSearch(input)}
						onFocus={() => setShowingLabel(false)}
						onBlur={() => setShowingLabel(true)}
						onClick={() => setShowingLabel(false)}
						value={search}
					/>
				</div>

				{search !== "" &&
					<>
						{Object.values(searchResults).length > 0 &&
							<div className={styles.search_outer_container} ref={divRef}>
								{Object.keys(searchResults).map((searchKey) => {
									let resultItem = searchResults[searchKey]

									return (
										<>
											{resultItem.map((item) => (
												<button className={styles.searchItem} onClick={() => handleClickItem(item, searchKey)}>
													<i className={`fa-solid fa-${searchKey === "events" ? "clipboard-check" : searchKey === "guestiis" ? "clipboard-user" : "users"} ${styles.m1}`}></i>

													{searchKey === "events"
														?
															<div className={styles.searchItemContent}>
																<p className={`${styles.s1}`}>{item.name}</p>
																<p className={`${styles.xs3}`}>{formatDate(item.start_date)} {convertTo24HourTime(item.start_date)} - {formatDate(item.end_date)} {convertTo24HourTime(item.end_date)}</p>
															</div>
														:
															<div className={styles.searchItemContent}>
																<p className={`${styles.s1}`}>{item.first_name} {item.last_name}</p>
																<p className={`${styles.xs3}`}>{item.email || item.phone}</p>
															</div>
													}
													
												</button>
											))}
										</>
									)
								})}
							</div>
						}
					</>
				}

				<button className={styles.profile_btn}><i className={`fa-solid fa-user ${styles.m1}`}></i></button>
			</div>
		</div>
	)
}

const InnerTopbar = ({ activeInnerTopbar, setActiveInnerTopbar }) => {
	return (
		<div className={styles.event_nav}>
			<button
				className={`${styles.event_nav_btn} ${activeInnerTopbar === "Dashboard" && styles.event_nav_btn_active}`}
				onClick={() => setActiveInnerTopbar('Dashboard')}
			>
				<p className={styles.s2}>Dashboard</p>
			</button>

			<button
				className={`${styles.event_nav_btn} ${activeInnerTopbar === "Guestiis" && styles.event_nav_btn_active}`}
				onClick={() => setActiveInnerTopbar('Guestiis')}
			>
				<p className={styles.s2}>Guestiis</p>
			</button>

			<button
				className={`${styles.event_nav_btn} ${activeInnerTopbar === "Team" && styles.event_nav_btn_active}`}
				onClick={() => setActiveInnerTopbar('Team')}
			>
				<p className={styles.s2}>Team</p>
			</button>

			<button
				className={`${styles.event_nav_btn} ${activeInnerTopbar === "Announcements" && styles.event_nav_btn_active}`}
				onClick={() => setActiveInnerTopbar('Announcements')}
			>
				<p className={styles.s2}>Announcements</p>
			</button>
		</div>
	)
}


const InnerSidebar = ({ event, eventOG, setEvent, reloadKey, setReloadKey, activeInnerTopbar, selectedGuestiis, setSelectedGuestiis, setMainLoading, mainLoading, setSettingTypes, setBulkEdit, setSettingTags, selectedTeam, setSelectedTeam, teamSelected, setTeamSelected, setSettingPlusOnes, selectedChannel, setSelectedChannel }) => {
	const [typeOptions, setTypeOptions] = useState([])
	const [tagOptions, setTagOptions] = useState([])
	const [promoterOptions, setPromoterOptions] = useState([])
	const [selectedFilters, setSelectedFilters] = useState([])
	const [roleOptions, setRoleOptions] = useState([])
	const [selectedPlusOneFilter, setSelectedPlusOneFilter] = useState(0)


	function formatDate(dateString) {
	    const date = new Date(dateString);

	    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	    const day = days[date.getDay()];
	    const dateNumber = date.getDate();
	    const month = months[date.getMonth()];

	    const suffix =
			dateNumber % 10 === 1 && dateNumber !== 11
			  	? 'st'
			  	: dateNumber % 10 === 2 && dateNumber !== 12
			  	? 'nd'
			  	: dateNumber % 10 === 3 && dateNumber !== 13
			  	? 'rd'
			  	: 'th';

	    return `${day}, ${dateNumber}${suffix} ${month}`;
	}

	function convertTo24HourTime(isoString) {
		const date = new Date(isoString);
		const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

		return time;
	}

	const generateQuickId = () => {
		const now = new Date();
		const timestamp = now.getTime();
		const random = Math.floor(Math.random() * 10000);

		return `${timestamp}-${random}`;
	};

	useEffect(() => {
		const handleTypes = async () => {
			const types = ["FREE", "PAY"]
			const typesWithIds = types.map(t => {
				return {
					type: t,
					id: generateQuickId()
				}
			})

			setTypeOptions(typesWithIds)
		}

		const handleTags = async () => {
			const eventTags = eventOG.guestiis.map(g => (g.tags && g.tags.length > 0) ? g.tags.map(t => t.tag).flat() : []).flat()

			let tagsRaw;
			if (eventTags && eventTags.length > 0) {
				const allTags = ["VIP", "CREW", "MEDIA", "STAFF", "GA"].concat(eventTags)
				tagsRaw = [...new Set(allTags)]
			} else {
				tagsRaw = ["VIP", "CREW", "MEDIA", "STAFF", "GA"]
			}

			const tagsWithIds = tagsRaw.map(t => {
				return {
					tag: t,
					id: generateQuickId()
				}
			})

			setTagOptions(tagsWithIds)
		}

		const handlePromoters = async () => {
			const eventPromoters = eventOG.guestiis.filter(g => g.source.role?.name === "Promoter").map(gi => `${gi.source.first_name} ${gi.source.last_name}`)
			const promotersDeDupped = [...new Set(eventPromoters)]
			const promotersWithIds = promotersDeDupped.map(p => {
				return {
					promoter: p,
					id: generateQuickId()
				}
			})

			setPromoterOptions(promotersWithIds)
		}

		const handleRoles = async () => {
			const roles = ["Account Owner", "Event Manager", "Promoter", "Scanner"]
			const rolesWithIds = roles.map(t => {
				return {
					role: t,
					id: generateQuickId()
				}
			})

			setRoleOptions(rolesWithIds)
		}

		setMainLoading(true)

		handleTypes()
		handleTags()
		handlePromoters()
		handleRoles()

		setMainLoading(false)
	}, [reloadKey]);


	const toggleFilters = (filter) => {
		setSelectedFilters((prev) => {
			const filtered = prev.find(p => p.id === filter.id)
				? [...prev].filter(f => f.id !== filter.id)
				: [...prev, filter]

			return filtered
		})
	}

	useEffect(() => {
		const handleFilters = () => {
			let filteredGuestiis;

			if (selectedFilters.length > 0) {
				const indEventGuestiis = activeInnerTopbar === "Guestiis" ? [...eventOG.guestiis] : [...eventOG.team]

				const typeNames = typeOptions.filter(t => selectedFilters.map(s => s.id).includes(t.id)).map(n => n.type)
				const tagNames = tagOptions.filter(t => selectedFilters.map(s => s.id).includes(t.id)).map(n => n.tag)
				const promoterNames = promoterOptions.filter(p => selectedFilters.map(s => s.id).includes(p.id)).map(n => n.promoter)
				const roleNames = roleOptions.filter(r => selectedFilters.map(s => s.id).includes(r.id)).map(n => n.role)
				const filterNames = tagNames.concat(promoterNames).concat(typeNames).concat(roleNames)

				let storedMatches =[]
				filteredGuestiis = indEventGuestiis.filter(g => {
					if (activeInnerTopbar === "Guestiis") {
						const guestiiTags = g.tags ? g.tags.map(t => t.tag) : []
						const tagMatch = guestiiTags.some(tag => filterNames.includes(tag));

						const guestiiPromoter = `${g.source.first_name} ${g.source.last_name}`
						const promoterMatch = guestiiPromoter ? filterNames.includes(guestiiPromoter) : false

						const typeMatch = g.ticket?.type ? filterNames.includes(g.ticket.type) : false

						const matchMade = tagMatch || promoterMatch || typeMatch
						if (matchMade) storedMatches.push(g.guestii._id.toString())
						const matchingMadeSource = !matchMade ? g.source ? storedMatches.includes(g.source._id.toString()) : false : false

						return matchMade || matchingMadeSource
					} else {
						const convertedRole = g.team_member.role.name === "SuperAdmin" ? "Account Owner" : g.team_member.role.name
						const roleMatch = filterNames.includes(convertedRole)

						return roleMatch
					}
				})
			} else {
				filteredGuestiis = activeInnerTopbar === "Guestiis" ? [ ...eventOG.guestiis ] : [ ...eventOG.team ]
			}

			if (activeInnerTopbar === "Guestiis") {
				setEvent((prev) => ({ ...prev, guestiis: filteredGuestiis }))
			} else {
				setEvent((prev) => ({ ...prev, team: filteredGuestiis }))
			}
		}
		
		handleFilters()
	}, [selectedFilters])


	useEffect(() => {
		const handlePlusOneFilter = () => {
			let filteredGuestiis;

			if (selectedPlusOneFilter && selectedPlusOneFilter !== 0) {
				const indEventGuestiis = [...eventOG.guestiis]
				filteredGuestiis = indEventGuestiis.filter(g => ((g.plus_ones || 0) >= selectedPlusOneFilter))
			} else {
				filteredGuestiis = [ ...eventOG.guestiis ]
			}

			setEvent((prev) => ({ ...prev, guestiis: filteredGuestiis }))
		}
		
		handlePlusOneFilter()
	}, [selectedPlusOneFilter])

	const marks = [
	    {
	        "value": 0,
	        "label": "0+"
	    },
	    {
	        "value": 1,
	        "label": "1+"
	    },
	    {
	        "value": 2,
	        "label": "2+"
	    },
	    {
	        "value": 3,
	        "label": "3+"
	    },
	    {
	        "value": 4,
	        "label": "4+"
	    },
	    {
	        "value": 5,
	        "label": "5+"
	    }
	]


	return (
		<div className={`${styles.sidebar_widget_container} ${(mainLoading && (activeInnerTopbar !== "Announcements")) && 'shine-animation'}`}>
			{!mainLoading &&
				<>
					{activeInnerTopbar === "Dashboard"
						?
							<div className={styles.fadeContainer}>
								<div className={`${styles.event_info_grid} ${(event.banner_img_url && event.banner_img_url !== "") && styles.banner_img_padding}`}>
									<div className={`${styles.indevent_banner} ${styles.event_info_item_name}`}>
										<div className={`${styles.event_banner} ${(event.banner_img_url && event.banner_img_url !== "") && styles.event_banner_np}`}>
											{(event.banner_img_url && event.banner_img_url !== "")
												? <img src={event.banner_img_url}/>
												: <img src={guestii_gif}/>
											}
										</div>

										<p className={`${styles.bold} ${styles.s3}`}>{event.name}</p>
									</div>

									<div className={styles.event_info_item}>
										<i className={`fa-solid fa-location-dot ${styles.m1}`}></i>
										<a className={styles.clickable_nav} href={`http://maps.google.com/?q=${event.location.formatted_address}`} target="_blank"><p className={styles.s1}>{event.location.formatted_address}</p></a>
									</div>

									<div className={styles.event_info_item}>
										<i className={`fa-solid fa-calendar-days ${styles.m1}`}></i>
										<p className={styles.s1}>{formatDate(event.start_date)}</p>
									</div>

									<div className={styles.event_info_item}>
										<i className={`fa-solid fa-clock ${styles.m1}`}></i>
										<p className={styles.s1}>{convertTo24HourTime(event.start_date)} - {convertTo24HourTime(event.end_date)}</p>
									</div>

									<div className={styles.event_info_item}>
										<i className={`fa-solid fa-users ${styles.m1}`}></i>
										<p className={styles.s1}>{event.capacity}{(event.capacityOG && event.capacityOG !== false) ? `/${event.capacityOG} capacity` : ' invited'}</p>
									</div>
								</div>
							</div>
						: activeInnerTopbar === "Guestiis"
						?
							<>
								{selectedGuestiis.length === 1
									?
										<div className={styles.fadeContainer}>
											<div className={styles.sidebar_heading_guestii_t}>
												<div className={`${styles.guestii_profile_rounded}`}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

												<div className={styles.sidebar_heading_guestii}>
													<p className={`${styles.s1}`}>{selectedGuestiis[0].guestii.first_name} {selectedGuestiis[0].guestii.last_name} {((!selectedGuestiis[0].guestii.first_name || selectedGuestiis[0].guestii.first_name === "") && (!selectedGuestiis[0].guestii.last_name || selectedGuestiis[0].guestii.last_name === "")) && "-"}</p>
													<p className={`${styles.xs3}`}>{selectedGuestiis[0].guestii.phone || "-"}</p>
												</div>

												<button className={styles.sidebar_exit_ind} onClick={() => setSelectedGuestiis([])}>
													<i className={`fa-solid fa-xmark ${styles.m1}`}></i>
												</button>
											</div>

											<p className={`${styles.xs3} ${styles.invited_by_banner}`}>Invited by: <span>{selectedGuestiis[0].source.first_name} {selectedGuestiis[0].source.last_name}</span></p>
											<p className={`${styles.xs3} ${styles.rating_banner}`}>Plus Ones: <span>{selectedGuestiis[0].plus_ones || 0}</span></p>
											<p className={`${styles.xs3} ${styles.rating_banner}`}>Ticket type: <span>{selectedGuestiis[0].ticket?.type || "FREE"}</span></p>
											{(selectedGuestiis[0].average_rating && selectedGuestiis[0].average_rating > 0) && <p className={`${styles.xs3} ${styles.rating_banner}`}>Guestii rating <span>{selectedGuestiis[0].average_rating}/5</span></p>}

											<div className={styles.sidebar_content_container}>
												<div className={styles.sidebar_filter_container}>
													<div className={styles.sidebar_heading}>
														<i className={`fa-solid fa-tag ${styles.m1}`}></i>
														<p className={`${styles.s1}`}>Tags</p>

														{/* {selectedGuestiis[0].tags.length > 0 && */}
														{/* 	<button className={styles.sidebar_edit}> */}
														{/* 		<i className={`fa-solid fa-pencil ${styles.s1}`}></i> */}
														{/* 	</button> */}
														{/* } */}
													</div>

													{selectedGuestiis[0].tags.length > 0
														?
															<div className={styles.filter_container}>
																{selectedGuestiis[0].tags.map((tag) => (
																	<div className={styles.filter_inner_container}>
																		<p className={`${styles.xs3}`}>{tag.tag}</p>
																	</div>
																))}
															</div>
														:
															<button
																className={styles.guestii_topbar_add_sidebar}
																onClick={() => {
																	setBulkEdit(true)
																	setSettingTags(selectedGuestiis)
																}}
															>
																<i className={`fa-solid fa-plus ${styles.s3}`}></i>
																<p className={`${styles.s1}`}>Assign</p>
															</button>
													}
												</div>
											</div>
										</div>
									: selectedGuestiis.length > 1
									?
										<div className={styles.fadeContainer}>
											<div className={styles.sidebar_heading_guestii_t}>
												<div className={`${styles.guestii_profile_rounded}`}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

												<div className={styles.sidebar_heading_guestii}>
													<p className={`${styles.s1}`}>{selectedGuestiis.length} Guestiis</p>
													<p className={`${styles.xs2}`}>selected</p>
												</div>

												<button className={styles.sidebar_exit_ind} onClick={() => setSelectedGuestiis([])}>
													<i className={`fa-solid fa-xmark ${styles.m1}`}></i>
												</button>
											</div>

											<div className={styles.sidebar_content_container}>
												<div className={styles.sidebar_filter_container}>
													<div className={styles.sidebar_heading}>
														<i className={`fa-solid fa-plus ${styles.m1}`}></i>
														<p className={`${styles.s1}`}>Plus Ones</p>
													</div>

													<button
														className={styles.guestii_topbar_add_sidebar}
														onClick={() => {
															setBulkEdit(true)
															setSettingPlusOnes(selectedGuestiis)
														}}
													>
														<i className={`fa-solid fa-plus ${styles.s3}`}></i>
														<p className={`${styles.s1}`}>Bulk Assign</p>
													</button>
												</div>

												<div className={styles.sidebar_filter_container}>
													<div className={styles.sidebar_heading}>
														<i className={`fa-solid fa-ticket ${styles.m1}`}></i>
														<p className={`${styles.s1}`}>Type</p>
													</div>

													<button
														className={styles.guestii_topbar_add_sidebar}
														onClick={() => {
															setBulkEdit(true)
															setSettingTypes(selectedGuestiis)
														}}
													>
														<i className={`fa-solid fa-plus ${styles.s3}`}></i>
														<p className={`${styles.s1}`}>Bulk Assign</p>
													</button>
												</div>

												<div className={styles.sidebar_filter_container}>
													<div className={styles.sidebar_heading}>
														<i className={`fa-solid fa-tag ${styles.m1}`}></i>
														<p className={`${styles.s1}`}>Tags</p>
													</div>

													<button
														className={styles.guestii_topbar_add_sidebar}
														onClick={() => {
															setBulkEdit(true)
															setSettingTags(selectedGuestiis)
														}}
													>
														<i className={`fa-solid fa-plus ${styles.s3}`}></i>
														<p className={`${styles.s1}`}>Bulk Assign</p>
													</button>
												</div>
											</div>
										</div>
									:
										<div className={styles.fadeContainer}>
											<div className={styles.sidebar_heading}>
												<i className={`fa-solid fa-filter ${styles.m1}`}></i>
												<p className={`${styles.s1}`}>Filter Guestiis</p>
											</div>

											<div className={styles.sidebar_content_container}>
												<div className={styles.sidebar_filter_container}>
													<div className={styles.sidebar_heading}>
														<i className={`fa-solid fa-ticket ${styles.m1}`}></i>
														<p className={`${styles.s1}`}>Types</p>
													</div>

													<div className={styles.filter_real_outer}>
														{typeOptions.map((type) => (
															<div className={styles.filter_real_container}>
																<button className={`${styles.filter_btn} ${selectedFilters.find(f => f.id === type.id) && styles.filter_btn_active}`} onClick={() => toggleFilters(type)}>
																	{selectedFilters.find(f => f.id === type.id) && <i className={`fa-solid fa-check ${styles.xs2}`}></i>}
																</button>

																<p className={`${styles.s1}`}>{type.type}</p>
															</div>
														))}
													</div>
												</div>

												<div className={styles.sidebar_filter_container}>
													<div className={styles.sidebar_heading}>
														<i className={`fa-solid fa-tag ${styles.m1}`}></i>
														<p className={`${styles.s1}`}>Tags</p>
													</div>

													<div className={styles.filter_real_outer}>
														{tagOptions.map((tag) => (
															<div className={styles.filter_real_container}>
																<button className={`${styles.filter_btn} ${selectedFilters.find(f => f.id === tag.id) && styles.filter_btn_active}`} onClick={() => toggleFilters(tag)}>
																	{selectedFilters.find(f => f.id === tag.id) && <i className={`fa-solid fa-check ${styles.xs2}`}></i>}
																</button>

																<p className={`${styles.s1}`}>{tag.tag}</p>
															</div>
														))}
													</div>
												</div>

												{(promoterOptions && promoterOptions.length > 0) &&
													<div className={styles.sidebar_filter_container}>
														<div className={styles.sidebar_heading}>
															<i className={`fa-solid fa-envelope ${styles.m1}`}></i>
															<p className={`${styles.s1}`}>Promoters</p>
														</div>

														<div className={styles.filter_real_outer}>
															{promoterOptions.map((promoter) => (
																<div className={styles.filter_real_container}>
																	<button className={`${styles.filter_btn} ${selectedFilters.find(f => f.id === promoter.id) && styles.filter_btn_active}`} onClick={() => toggleFilters(promoter)}>
																		{selectedFilters.find(f => f.id === promoter.id) && <i className={`fa-solid fa-check ${styles.xs2}`}></i>}
																	</button>

																	<p className={`${styles.s1}`}>{promoter.promoter}</p>
																</div>
															))}
														</div>
													</div>
												}

												<div className={styles.sidebar_filter_container}>
													<div className={styles.sidebar_heading}>
														<i className={`fa-solid fa-plus ${styles.m1}`}></i>
														<p className={`${styles.s1}`}>Plus Ones</p>
													</div>

													<div className={styles.filter_real_outer_slider}>
														<div className={styles.slider_container}>
										                  	<div className={styles.slider_inner}>
										                    	<Slider
																	defaultValue={0}
																	valueLabelDisplay="auto"
																	marks={marks}
																	min={0}
																	max={5}
																	step={1}
																	onChange={(input) => setSelectedPlusOneFilter(input.target.value)}
																	value={selectedPlusOneFilter}
										                      		sx={{
										                          		'& .MuiSlider-thumb': {
										                            		color: "#449dd1 !important"
										                          		},
										                          		'& .MuiSlider-thumb:hover': {
										                            		boxShadow: '0px 0px 0px 8px rgba(255, 172, 27, 0.16) !important'
										                          		},
										                          		'& .MuiSlider-track': {
										                            		color: "#449dd1 !important"
										                          		},
										                          		'& .MuiSlider-rail': {
										                            		color: "#ffffff !important"
										                          		},
										                          		'& .MuiSlider-active': {
										                            		color: "#449dd1 !important"
										                         		},
										                          		'& .MuiSlider-markLabel': {
										                            		color: "#449dd1 !important",
										                            		textDecoration: "none !important",
										                            		fontFamily: "unset !important"
										                          		},
										                          		'& .MuiSlider-valueLabel': {
										                            		backgroundColor: "#449dd1 !important",
										                            		textDecoration: "none !important"
										                          		},
										                          		'& .MuiSlider-valueLabelCircle': {
										                            		textDecoration: "none !important"
										                          		},
										                          		'& .MuiSlider-valueLabelLabel': {
										                            		color: "white !important",
										                            		textDecoration: "none !important"
										                          		}
										                      		}}
										                    	/>
										                  	</div>
										                </div>
									                </div>
												</div>
											</div>
										</div>
								}
							</>
						: activeInnerTopbar === "Team"
						?
							<>
								{selectedTeam
									?
										<div className={styles.fadeContainer}>
											<div className={styles.sidebar_heading_guestii_t}>
												<div className={`${styles.guestii_profile_rounded}`}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

												<div className={styles.sidebar_heading_guestii}>
													<p className={`${styles.s1}`}>{selectedTeam.team_member.first_name} {selectedTeam.team_member.last_name}</p>
													<p className={`${styles.xs3}`}>{selectedTeam.team_member.email || "-"}</p>
												</div>

												<button className={styles.sidebar_exit_ind} onClick={() => setSelectedTeam(null)}>
													<i className={`fa-solid fa-xmark ${styles.m1}`}></i>
												</button>
											</div>

											<p className={`${styles.xs3} ${styles.invited_by_banner}`}>Role: <span>{selectedTeam.team_member.role.name}</span></p>
											{selectedTeam.team_member.role.name === "Promoter" && <p className={`${styles.xs3} ${styles.rating_banner}`}>Limit: <span>{selectedTeam.limit === 0 ? "Unlimited" : selectedTeam.limit}</span></p>}
											<p className={`${styles.xs3} ${styles.rating_banner}`}>Invited by: <span>{selectedTeam.source.first_name} {selectedTeam.source.last_name}</span></p>

											{/* <div className={styles.sidebar_content_container}> */}
											{/* </div> */}
										</div>
									:
										<div className={styles.fadeContainer}>
											<div className={styles.sidebar_heading}>
												<i className={`fa-solid fa-filter ${styles.m1}`}></i>
												<p className={`${styles.s1}`}>Filter Team</p>
											</div>

											<div className={styles.sidebar_content_container}>
												<div className={styles.sidebar_filter_container}>
													<div className={styles.sidebar_heading}>
														<i className={`fa-solid fa-user ${styles.m1}`}></i>
														<p className={`${styles.s1}`}>Roles</p>
													</div>

													<div className={styles.filter_real_outer}>
														{roleOptions.map((role) => (
															<div className={styles.filter_real_container}>
																<button className={`${styles.filter_btn} ${selectedFilters.find(f => f.id === role.id) && styles.filter_btn_active}`} onClick={() => toggleFilters(role)}>
																	{selectedFilters.find(f => f.id === role.id) && <i className={`fa-solid fa-check ${styles.xs2}`}></i>}
																</button>

																<p className={`${styles.s1}`}>{role.role}</p>
															</div>
														))}
													</div>
												</div>
											</div>
										</div>
								}
							</>
						:
							<div className={styles.fadeContainer}>
								<div className={styles.sidebar_heading}>
									<i className={`fa-solid fa-bullhorn ${styles.m1}`}></i>
									<p className={`${styles.s1}`}>Announcements</p>
								</div>

								<div className={styles.sidebar_content_container}>
									<div className={styles.sidebar_filter_container}>
										<div className={styles.sidebar_heading}>
											<i className={`fa-solid fa-user ${styles.m1}`}></i>
											<p className={`${styles.s1}`}>Channels</p>
										</div>

										<div className={styles.filter_real_outer}>
											{["Guestiis", "Team"].map((channel) => (
												<div className={styles.filter_real_container}>
													<button className={`${styles.filter_btn} ${selectedChannel === channel && styles.filter_btn_active}`} onClick={() => setSelectedChannel(channel)}>
														{selectedChannel === channel && <i className={`fa-solid fa-check ${styles.xs2}`}></i>}
													</button>

													<p className={`${styles.s1}`}>{channel}</p>
												</div>
											))}
										</div>
									</div>
								</div>
							</div>
					}
				</>
			}
		</div>
	)
}


const InnerContent = ({ event, eventOG, setEvent, setEventOG, activeInnerTopbar, mainLoading, selectedGuestiis, setSelectedGuestiis, selectedTeam, setSelectedTeam, setInvitingGuestii, setInvitingTeam, settingTags, setSettingTags, toggledMenu, setToggledMenu, setSettingRating, setSettingTypes, setMainReloadKey, setSettingLimits, setSettingPlusOnes, settingPlusOnes, settingTypes, settingRating, settingLimits, selectedChannel, setSettingPromoters, settingPromoters }) => {
	return (
		<div className={`${styles.content_widget_container} ${styles.fadeContainer}`}>
			{activeInnerTopbar === "Dashboard"
				? 	
					<DashboardModule
						event={event}
						mainLoading={mainLoading}
					/>
				: activeInnerTopbar === "Guestiis"
				?
					<GuestiiModule
						event={event}
						eventOG={eventOG}
						setEvent={setEvent}
						setEventOG={setEventOG}
						mainLoading={mainLoading}
						selectedGuestiis={selectedGuestiis}
						setSelectedGuestiis={setSelectedGuestiis}
						setInvitingGuestii={setInvitingGuestii}
						settingTags={settingTags}
						setSettingTags={setSettingTags}
						toggledMenu={toggledMenu}
						setToggledMenu={setToggledMenu}
						setSettingRating={setSettingRating}
						setSettingTypes={setSettingTypes}
						setMainReloadKey={setMainReloadKey}
						setSettingPlusOnes={setSettingPlusOnes}
						settingPlusOnes={settingPlusOnes}
						settingTypes={settingTypes}
						settingRating={settingRating}
						setSettingPromoters={setSettingPromoters}
						settingPromoters={settingPromoters}
					/>
				: activeInnerTopbar === "Team"
				?
					<TeamModule
						event={event}
						eventOG={eventOG}
						setEvent={setEvent}
						setEventOG={setEventOG}
						mainLoading={mainLoading}
						selectedTeam={selectedTeam}
						setSelectedTeam={setSelectedTeam}
						setInvitingTeam={setInvitingTeam}
						setSettingLimits={setSettingLimits}
						toggledMenu={toggledMenu}
						setToggledMenu={setToggledMenu}
						setMainReloadKey={setMainReloadKey}
						settingLimits={settingLimits}
					/>
				:
					<AnnouncementsModule
						event={event}
						mainLoading={mainLoading}
						selectedChannel={selectedChannel}
						setMainReloadKey={setMainReloadKey}
					/>
			}
		</div>
	)
}



const IndEvent = () => {
	const param = useParams();
	const [loadedOnce, setLoadedOnce] = useState(false)
	const [mainReloadKey, setMainReloadKey] = useState(0)
	const [reloadKey, setReloadKey] = useState(0)
	const [mainLoading, setMainLoading] = useState(true);
	const [event, setEvent] = useState(null)
	const [eventOG, setEventOG] = useState(null)
	const [selectedGuestiis, setSelectedGuestiis] = useState([])
	const [selectedTeam, setSelectedTeam] = useState(null)
	const [activeInnerTopbar, setActiveInnerTopbar] = useState("Dashboard")
	const [invitingGuestii, setInvitingGuestii] = useState(false)
	const [invitingTeam, setInvitingTeam] = useState(false)
	const [settingTags, setSettingTags] = useState([])
	const [settingTypes, setSettingTypes] = useState([])
	const [toggledMenu, setToggledMenu] = useState(null)
	const [settingRating, setSettingRating] = useState(false)
	const [bulkEdit, setBulkEdit] = useState(false)
	const [settingLimits, setSettingLimits] = useState([])
	const [teamSelected, setTeamSelected] = useState([])
	const [settingPlusOnes, setSettingPlusOnes] = useState([])
	const [selectedChannel, setSelectedChannel] = useState("Guestiis")
	const [settingPromoters, setSettingPromoters] = useState([])


	useEffect(() => {
		const getEvent = async () => {
			setMainLoading(true)

			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}

		  	try {
			    const res = await axios.get(`/api/events/${param.event_id}`, {
			      	headers: {
			        	'x-user-id': userId,
			        	'x-expiry': expiry
			      	}
			    });

			    if (!res.data.event) {
			    	window.location = `/hub/${userId}`
			    }

			    if (res.data.event.guestiis.length === 0 && !loadedOnce) {
			    	setActiveInnerTopbar("Guestiis")
			    }

		    	setEvent(res.data.event)
		    	setEventOG(res.data.event)
		  	} catch (err) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
		  	}

		  	setReloadKey((prevKey) => prevKey + 1)
			setMainLoading(false)
			setLoadedOnce(true)
		}

		getEvent()
	}, [activeInnerTopbar, mainReloadKey]);


	const handleCloseEllipsis = (bypass=false) => {
		setSettingRating(false)
		setSettingTypes([])
		setSettingTags([])
		setBulkEdit(false)
		setSettingLimits([])
		setSettingPlusOnes([])
		setSettingPromoters([])

		if (bypass) { return; }

		setToggledMenu(null)
		setSelectedGuestiis([])
		setSelectedTeam(null)
		setMainReloadKey((prevMainKey) => prevMainKey + 1);
	}


	return (
		<div className={`${styles.indevent_outer} ${styles.fadeContainer} ${(invitingGuestii || invitingTeam || settingTags.length > 0 || settingRating || settingTypes.length > 0 || settingPlusOnes.length > 0 || settingLimits.length > 0 || settingPromoters.length > 0) && styles.white_overlay}`}>
			<div className={`${styles.container} ${(invitingGuestii || invitingTeam || settingTags.length > 0 || settingRating || settingTypes.length > 0 || settingPlusOnes.length > 0 || settingLimits.length > 0 || settingPromoters.length > 0) && styles.hidden_container}`}>
				<Sidebar current={"Hub"}/>

				<div className={styles.content_container}>
					<Banner/>

					<div className={styles.hub_layout}>
						{event && 
							<InnerTopbar
								activeInnerTopbar={activeInnerTopbar}
								setActiveInnerTopbar={setActiveInnerTopbar}
							/>
						}

						{event &&
							<InnerSidebar
								event={event}
								eventOG={eventOG}
								setEvent={setEvent}
								reloadKey={reloadKey}
								setReloadKey={setReloadKey}
								activeInnerTopbar={activeInnerTopbar}
								selectedGuestiis={selectedGuestiis}
								setSelectedGuestiis={setSelectedGuestiis}
								setMainLoading={setMainLoading}
								mainLoading={mainLoading}
								setSettingTypes={setSettingTypes}
								setBulkEdit={setBulkEdit}
								setSettingTags={setSettingTags}
								selectedTeam={selectedTeam}
								setSelectedTeam={setSelectedTeam}
								teamSelected={teamSelected}
								setTeamSelected={setTeamSelected}
								setSettingPlusOnes={setSettingPlusOnes}
								selectedChannel={selectedChannel}
								setSelectedChannel={setSelectedChannel}
							/>
						}

						{event && 
							<InnerContent
								event={event}
								eventOG={eventOG}
								setEvent={setEvent}
								setEventOG={setEventOG}
								activeInnerTopbar={activeInnerTopbar}
								mainLoading={mainLoading}
								selectedGuestiis={selectedGuestiis}
								setSelectedGuestiis={setSelectedGuestiis}
								selectedTeam={selectedTeam}
								setSelectedTeam={setSelectedTeam}
								setInvitingGuestii={setInvitingGuestii}
								setInvitingTeam={setInvitingTeam}
								settingTags={settingTags}
								setSettingTags={setSettingTags}
								toggledMenu={toggledMenu}
								setToggledMenu={setToggledMenu}
								setSettingRating={setSettingRating}
								setSettingTypes={setSettingTypes}
								setMainReloadKey={setMainReloadKey}
								setSettingLimits={setSettingLimits}
								teamSelected={teamSelected}
								setTeamSelected={setTeamSelected}
								setSettingPlusOnes={setSettingPlusOnes}
								settingPlusOnes={settingPlusOnes}
								settingTypes={settingTypes}
								settingRating={settingRating}
								settingLimits={settingLimits}
								selectedChannel={selectedChannel}
								setSettingPromoters={setSettingPromoters}
								settingPromoters={settingPromoters}
							/>
						}
					</div>
				</div>
			</div>

			{invitingGuestii &&
				<InviteGuestiiModule
					setInvitingGuestii={setInvitingGuestii}
					setMainReloadKey={setMainReloadKey}
				/>
			}

			{invitingTeam &&
				<InviteTeamModule
					event={event}
					setMainReloadKey={setMainReloadKey}
					setInvitingTeam={setInvitingTeam}
					selectedTeam={selectedTeam}
					setSelectedTeam={setSelectedTeam}
					teamSelected={teamSelected}
					setTeamSelected={setTeamSelected}
				/>
			}

			{settingTypes.length > 0 &&
				<GuestiiTypes
					handleClose={handleCloseEllipsis}
					settingTypes={settingTypes}
					toggledMenu={toggledMenu}
					setMainReloadKey={setMainReloadKey}
					bulkEdit={bulkEdit}
				/>
			}

			{settingTags.length > 0 &&
				<GuestiiTags
					handleClose={handleCloseEllipsis}
					settingTags={settingTags}
					toggledMenu={toggledMenu}
					setMainReloadKey={setMainReloadKey}
					bulkEdit={bulkEdit}
				/>
			}

			{settingPlusOnes.length > 0 &&
				<GuestiiPlusOnes
					handleClose={handleCloseEllipsis}
					settingPlusOnes={settingPlusOnes}
					toggledMenu={toggledMenu}
					setMainReloadKey={setMainReloadKey}
					bulkEdit={bulkEdit}
				/>
			}


			{settingPromoters.length > 0 &&
				<GuestiiPromoters
					handleClose={handleCloseEllipsis}
					settingPromoters={settingPromoters}
					toggledMenu={toggledMenu}
				/>
			}

			{settingRating &&
				<GuestiiRating
					handleClose={handleCloseEllipsis}
					toggledMenu={toggledMenu}
				/>
			}

			{settingLimits.length > 0 &&
				<PromoterLimits
					handleClose={handleCloseEllipsis}
					settingLimits={settingLimits}
					toggledMenu={toggledMenu}
				/>
			}
		</div>
	);
};

export default IndEvent;